import { RootState } from '@/store/types';
import { OrderPaymentState } from './types';
import { GetterTree } from 'vuex';
export const getters: GetterTree<OrderPaymentState, RootState> = {
  status: (state) => state.status,
  feedbackStatistics: (state) => state.feedbackStatistics,
  dailyStatistics: (state) => state.dailyStatistics
};
